import { en } from './en';
import { th } from './th';

export const DEFAULT_LOCALE = 'th' as const;
export const LOCALES = ['th', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

/** i18next-compatible resource bundles, namespaced. */
export const resources = {
  th,
  en,
} as const;

export { en, th };
